import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';

import { Modal } from 'react-bootstrap';

export const ModalWrapper = styled(Modal)`
  & .zonebg--modal {
    background-position: top;
    margin: 0 auto;
    max-width: 345px !important;
    font-family: 'Poppins';
    border: none !important;
    border-radius: 30px !important;
    color: white;
    background: #333740;
    overflow: hidden;
  }

  & .modal-header {
    padding: 18px 20px 15px 20px;
    z-index: 3;
    border-radius: 0px;
    border: none !important;

    & .modal-title {
      font-weight: 600;
      font-size: 18px;
      line-height: 130%;
      /* color: rgba(0, 0, 0, 0.7); */
    }
    & .btn-close {
      width: 14px;
      height: 14px;
      padding: 0px;
      border: none;
      opacity: 1;
      margin: 0px;
    }
  }
  & .modal-body {
    display: flex;
    flex-direction: column;
    padding: 33px 36px 33px 36px;
    background: linear-gradient(180deg, #181a1f 0%, #333740 100%);
    border: 1px solid rgba(255, 255, 255, 0.2);
    z-index: 3;
    border-radius: 30px;
    color: inherit;
  }
`;
export const TextBtn = styled.a`
  color: rgba(255, 220, 94, 1);
`;

export const WalletErrorContainer = styled.div`
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 15px;
  & > span {
    width: 300px;
  }
  & .get-wallet-btn {
    @media screen and (max-width: 767px) {
      max-width: 128px;
    }
  }
`;
export const CustomModal = styled(Modal)`
  & .modal-dialog {
    max-width: 400px !important;
    @media (max-width: 767px) {
      margin: 0px;
    }
  }
  & .modal-body {
    padding: 0rem;
  }
  & .modal-content {
    min-height: 250px;
    max-width: 400px !important;
    background: linear-gradient(0deg, #282d33, #282d33),
      linear-gradient(0deg, #2f3037, #2f3037), #282d33;
    border-radius: 30px;
    @media (max-width: 767px) {
      width: 100% !important;
      height: 100% !important;
      border-radius: 0px;
    }
  }
`;

export const CloseButtonWrapper = styled.div`
  height: 30px;
  width: 30px;
  top: 13px;
  right: 10px;
  border-radius: 50%;
  position: absolute;
  background: #3e4247;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const LoginSignUpContainer = styled.div`
  padding: 1rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
`;

export const Header = styled.div`
  border-bottom: 0.8px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 15px;
  @media screen and (max-width: 767px) {
    &.hideBorder {
      border-bottom: 0px;
      padding-bottom: 5px;
    }
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  flex-grow: 1;
  background: #0b0c0b;
  font-family: 'Poppins', sans-serif;
  @media only screen and (min-width: 992px) {
    height: 100vh;
  }
`;

export const BodyWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-grow: 1;
  height: 100%;
  position: relative;
  flex-direction: column;
  flex: 1;
`;

export const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px;
  @media (max-width: 480px) {
    padding: 0px 15px;
  }
`;

export const NavbarContainer = styled(Navbar)`
  padding: 0 !important;
  position: sticky;
  top: 0px;
  z-index: 10;
  justify-content: space-between;
  background: transparent;
  backdrop-filter: blur(10px);

  & .navbar-toggler {
    border: 1px solid #fcac01;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    padding: 6px;
    margin-right: 16px;
    @media screen and (min-width: 375px) {
      margin-right: 25px;
    }
    & .navbar-toggler-icon {
      filter: invert(1);
      width: 18px;
      height: 18px;
    }
  }

  & .navbar-collapse-container {
    margin-top: 12px;

    height: calc(100vh - 73px);
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 992px) {
      display: none;
    }
  }
  @media (max-width: 480px) {
    position: sticky;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(25px);
  }
  @media screen and (max-width: 1199px) {
    padding: 16px 40px;
  }
  @media screen and (max-width: 991px) {
    padding: 18px 15px;
    min-height: 73px;
    /* background: #1b1d20 !important; */
  }
  &.onScroll {
    background: radial-gradient(
      106.75% 100% at 57.5% 100%,
      rgb(194 147 0 / 88%) 0%,
      rgb(56 39 29) 100%
    );
  }
`;

export const NavLogoWrapper = styled.span`
  display: flex;
  align-items: end;
  max-width: 77px;
  max-height: 50px;
  overflow: hidden;
  flex-shrink: 0;
  text-decoration: none;
  cursor: pointer;
  width: 77px;
  //height: 36px;
  overflow: visible;
  & img {
    width: 100% !important;
    height: 100% !important;
    max-width: 100%;
    max-height: 100%;
  }
  @media screen and (max-width: 480px) {
    margin-left: -10px;
  }
  @media screen and (min-width: 375px) {
    max-width: 77px;
  }
`;

export const NavbarButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0px;
  background-color: transparent;
  border: 1px solid #fcc601;
  border-radius: 10px;
  color: #ffffffb2;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  padding: 6px 10px;
  min-width: 120px;
  min-height: 36px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  & .help-brn-text {
    margin-left: 10px !important;
  }
  & a {
    max-width: 167px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #ffffffb2 !important;
    text-decoration: none !important;
    &.help-support-link {
      display: flex;
    }
    &:hover,
    &:focus,
    &:active {
      color: black !important;
      &.help-support-link {
        color: #fff !important;
      }
    }
  }
  &:not(:disabled):not(.disabled):active:focus,
  &:not(:disabled):not(.disabled):active,
  &:not(:disabled):not(.disabled):active,
  &:hover,
  &:focus {
    background: linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%);
    color: black !important;
    border: 1px solid #fcc601;
    outline: none;
    box-shadow: none;
    &.help-btn {
      color: #ffffffb2 !important;
    }
  }
  &.button-yellow {
    color: black;
    box-shadow: none;
    background: linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%);

    &:not(:disabled):not(.disabled):active:focus,
    &:not(:disabled):not(.disabled):active,
    &:not(:disabled):not(.disabled):active,
    &:hover,
    &:focus {
      color: black;
      border: 1px solid #fcc601;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      outline: none;
    }
    & span {
      max-width: 167px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  &.help-btn {
    &:hover,
    &:active,
    &:focus {
      background: none !important;
    }
  }

  @media screen and (min-width: 375px) {
    min-width: 142px;
    font-size: 14px;
    line-height: 21px;
  }
  @media screen and (min-width: 992px) {
    min-width: 100px;
    min-height: 40px;
  }
  &.navbar-btn {
    width: 50px;
    min-height: 50px;
  }
  @media screen and (max-width: 320px) {
    padding: 6px 6px;
  }
`;

export const Text = styled.div`
  color: white;
  user-select: none;
  &.mainBal {
    font-weight: 600;
  }
  &.usdPrice {
    opacity: 0.6;
    font-size: 14px;
  }
  &.plusTxt {
    color: black;
    font-size: 26px;
  }
  &.walletAdd {
    font-size: 14px;
    width: 100%;
  }
  @media screen and (max-width: 991px) {
    font-size: 13px;
    &.usdPrice {
      font-size: 13px;
    }
  }
  @media screen and (max-width: 480px) {
    &.walletAdd {
      width: 100px;
    }
  }
`;

export const Title = styled.h3`
  font-weight: 700;
  font-size: 18px;
  line-height: 130%;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.9);
  @media (max-width: 767px) {
    font-size: 16px;
    &.bgDarkMobile {
      color: rgba(0, 0, 0, 0.9);
    }
  }
  &.subTitle {
    font-size: 15px;
    margin: 25px 0px;
  }
  &.signUpTitle {
    font-size: 16px;
    margin-top: 18px;
    & > span {
      color: #ffdc5e;
      cursor: pointer;
    }
  }
`;
export const InputWrapper = styled.div`
  position: relative;
`;
export const IconWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 12px;
`;

export const Divider = styled.div`
  border-bottom: 0.8px solid rgba(255, 255, 255, 0.3);
  width: 45%;
`;
export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ResendTitleWrapper = styled.div`
  color: rgb(255, 255, 255, 70%);
  font-size: 15px;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  & .text-right {
    text-align: right;
  }
  & .timer {
    color: #fff;
  }
  & .resendBtn {
    color: #ffdc5e;
    text-decoration: underline;
    cursor: pointer;
  }
`;
export const BlockChainWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  height: 41px;
  padding: 0px 15px;
  // padding: 13px 16px 13px 21px;
  cursor: pointer;
  &.selected {
    background: linear-gradient(
      92.97deg,
      rgba(255, 220, 94, 0.2) 0.13%,
      rgba(252, 198, 1, 0.2) 99.87%
    );
    border: 1px solid rgba(253, 205, 29, 0.3);
  }
`;
export const ChainsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const RadioButton = styled(Form.Check)`
  cursor: pointer;
  display: flex;
  align-items: center;
  & > input,
  & > label {
    cursor: pointer;
  }
  & .form-check-input {
    background-color: #313439;
  }
  & .form-check-input:checked {
    background: linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%),
      #3c3f46;
    position: relative;
    &:after {
      position: absolute;
      top: 0px;
      left: 2px;
      font-size: 10px;
      content: url(https://static.zone.game/images/homapage/checkedIcon.svg);
    }
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  & > label {
    margin-left: 9px;
  }
`;
export const WalletDetailContainer = styled.div`
  @media screen and (min-width: 992px) {
    height: calc(100vh - 240px);
  }
`;
export const WithdrawContainer = styled.div`
  @media screen and (min-width: 992px) {
    height: calc(100vh - 220px);
  }
`;
